/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { components, StylesConfig, OptionTypeBase } from 'react-select';

interface IOptions {
    hasIcon?: boolean;
    sideBorders?: boolean;
    hideBorder?: boolean;
    width?: string;
    height?: string;
}

export const generateSelectStyles = ({
    hasIcon,
    sideBorders,
    width,
    hideBorder,
    height,
}: IOptions): StylesConfig<OptionTypeBase, false> => ({
    option: (base, { isSelected, isFocused, isDisabled }) => ({
        ...base,
        color: isDisabled ? '#CCCCCC' : '#1C1C1C',
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: isSelected ? '#F2F8FB' : isFocused ? '#E5F1F8' : 'white',
        border: 'none',
        height: 30,
        borderRadius: '0%',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
    }),
    singleValue: (base) => ({
        ...base,
        height: 18,
        width: 150,
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: 'white',
        border: '1px solid #CCCCCC',
        borderRadius: 0,
        fontSize: 12,
        zIndex: 999,
        top: 21,
        position: 'absolute',
    }),
    control: (base) => ({
        ...base,
        borderRadius: 0,
        fontSize: 12,
        minHeight: 30,
        height: height || 30,
        backgroundColor: 'transparent',
        border: hideBorder ? 'none' : base.border,
        boxShadow: 'none',
        borderColor: '#BFC8D0',
        '&:hover': { borderColor: '#0277BD' },
    }),
    placeholder: (base) => ({
        ...base,
        color: '#424242',
        fontSize: 12,
        fontWeight: 600,
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    container: (base) => ({
        ...base,
        width: width || 180,
        height: height || 30,
        ...(sideBorders ? { borderLeft: '1px solid #D9DADB', borderRight: '1px solid #D9DADB' } : {}),
    }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: hasIcon ? 24 : base.paddingLeft,
    }),
});

const ChevronIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: 12,
    color: theme.colors.neutral300,
}));

export const DropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
        <ChevronIcon icon={['fas', 'angle-down']} />
    </components.DropdownIndicator>
);

const SearchIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: 13,
    color: theme.colors.primary300,
    marginLeft: 5,
    position: 'absolute',
    left: 2,
}));

export const ValueContainer = (props: any) => (
    <components.ValueContainer {...props}>
        <SearchIcon icon="search" />
        {props.children}
    </components.ValueContainer>
);
